export interface LoginState {
    user: Record<string, any> | null;
}

export const loginState: LoginState = {
    user: null
}